import { c as _c } from "react/compiler-runtime";
import { KeyValueGrid } from "@/components/domain/key-value-grid";
import { KeyValueSkeleton } from "@/components/domain/key-value-skeleton";
import { ReportSection } from "@/components/domain/report-section";
import { sections } from "@/lib/constants/sections";
export function RegistrationSectionSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ReportSection isLoading={true} {...sections.registration}><KeyValueGrid colsDesktop={2}><KeyValueSkeleton label="Registrar" withLeading={true} widthClass="w-[120px]" /><KeyValueSkeleton label="Registrant" widthClass="w-[100px]" /><KeyValueSkeleton label="Created" withSuffix={true} widthClass="w-[90px]" /><KeyValueSkeleton label="Expires" withSuffix={true} widthClass="w-[90px]" /></KeyValueGrid></ReportSection>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}